import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import { HomeDoctor } from './components/HomeDoctor';
import { Layout } from './components/Layout';
import { LoginForm } from './components/LoginForm';
import { PatientRequest } from './components/PatientRequest';
import { StatusPage } from './components/StatusPage';
import { ProductList } from './components/ProductList';
import { ProductRequest } from './components/ProductRequest';
import RequireAuth from './components/RequireAuth';
import { ThankYouPage } from './components/ThankYouPage';
import { ThankYouPagePatient } from './components/ThankYouPagePatient';
import { ErrorPage } from './components/ErrorPage';
import { ProfilePage } from './components/ProfilePage';
import { ForgotPassword } from './components/ForgotPassword';
import { ResetPassword } from './components/ResetPassword';
import { CambiarPasswordVencida } from './components/CambiarPasswordVencida';

const ROLES = {
  'BACKOFFICE': 1,
  'DOCTOR': 2,
  'ADMIN': 3
};

function App() {
  return (
    <Routes>
      {/* PUBLIC */}
      <Route path="/login" element={<LoginForm />} />
      <Route path="/recuperar-contrasena" element={<ForgotPassword />} />
      <Route path="/recuperar-contraseña" element={<ForgotPassword />} />
      <Route path="/restablecer-contrasena" element={<ResetPassword />} />
      <Route path="/restablecer-contraseña" element={<ResetPassword />} />
      <Route path="/cambiarPasswordVencida" element={<CambiarPasswordVencida />} />

      {/* PRIVATE / GENERAL */}
      <Route path="/" element={<Layout />}>
        <Route element={<RequireAuth allowedRoles={[ROLES.DOCTOR]} />}>
          <Route index element={<HomeDoctor />} />
          <Route path="productos" element={<ProductList />} />
          <Route path="pedido-producto" element={<ProductRequest />} />
          <Route path="enviado" element={<ThankYouPage />} />
          <Route path="perfil" element={<ProfilePage />} />
        </Route>

        <Route path="pedido/:hashPaciente" element={<PatientRequest />} />
        <Route path="pedido/status/:hashPaciente" element={<StatusPage />} />
        <Route path="pedido/enviado/:hashPaciente" element={<ThankYouPagePatient />} />
        <Route path="pedido/error" element={<ErrorPage />} />
      </Route>

      <Route path="*" element={<Navigate to="/login" />} />
    </Routes>
  );
}

export default App;